export enum CardType {
    Monster,
    Action,
    Resource,
    Tool,
    Curse,
}